import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('packageWeight', packageWeight);

function packageWeight($filter) {
  return function bringozPackageWeight(packageList, enableUnitDisplay) {
    let totalWeight = 0;
    let hasAnyWeight = false;

    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          pkg.items.forEach(item => {
            if (item.weight !== undefined) {
              hasAnyWeight = true;
            }
            totalWeight += item.weight || 0;
          });
        }
      });
    }

    return hasAnyWeight ? $filter('bringozWeight')(totalWeight, enableUnitDisplay) : '--';
  };
}
